<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-08-29 10:31:33
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 16:16:47
-->
<template>
  <ux-form
    ref="form"
    width="450px"
    :data="formData"
    :colon="true"
    :rules="rules"
    data-automation="addApply"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.unbindApply.name')" required prop="name">
      <ux-input
        v-model="formData.name"
        :maxlength="30"
        :placeholder="$t('HT.rules.addApply.name')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '',
          remark: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addApply()
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
